webpackJsonp([4],{

/***/ "0xDb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getOpenId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getScreenInfo; });
var getOpenId = function getOpenId() {
    return window.localStorage.getItem('openId');
};

var getScreenInfo = function getScreenInfo() {
    var width = window.innerWidth;
    var height = window.innerHeight;
    var rWidth = 7.5;
    var rHeight = (7.5 * height / width).toFixed(2);
    return {
        width: width,
        height: height,
        rWidth: rWidth,
        rHeight: rHeight
    };
};

/***/ }),

/***/ "Apws":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// CONCATENATED MODULE: ./src/utils/request.js




axios_default.a.defaults.headers.post['Content-Type'] = 'application/json';

var service = axios_default.a.create({
  baseURL: "",
  timeout: 10000
  // withCredentials: true,
});

service.interceptors.request.use(function (config) {
  if (config.data) {
    var data = null;
    try {
      data = stringify_default()(config.data);
    } catch (error) {
      data = config.data;
    }
    config.data = data;
  }
  return config;
}, function (error) {
  return promise_default.a.reject(error);
});

service.interceptors.response.use(function (response) {
  if (response.status === 200) {
    return response.data;
  }
  return response;
}, function (error) {
  return promise_default.a.reject(error);
});

var get = function get(api, params) {
  return service({
    url: api,
    method: 'get',
    params: params
  });
};

var post = function post(api, params) {
  return service({
    url: api,
    method: 'post',
    data: params
  });
};

var del = function del(api, params) {
  return service({
    url: api,
    method: 'delete',
    data: params
  });
};

/* harmony default export */ var request = (service);
// CONCATENATED MODULE: ./src/apis/index.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return apis_getJssdkSingature; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return apis_donate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return apis_reportPaySuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return apis_getCertByOrderNo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return apis_queryCertList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return apis_queryPayConfig; });


// 获取微信jssdk签名
var apis_getJssdkSingature = function getJssdkSingature(params) {
    return post('/wxJsapiSignature', params);
};
// 捐赠
var apis_donate = function donate(params) {
    return post('/wx/order/book', params);
};
// 支付成功
var apis_reportPaySuccess = function reportPaySuccess(params) {
    return get('/wx/pay/changePayStatus2Paying/' + params.orderNo);
};
// 根据orderNo查询证书
var apis_getCertByOrderNo = function getCertByOrderNo(params) {
    return get('/wx/certificate/findByOrderNo/' + params.orderNo);
};
// 查询证书
var apis_queryCertList = function queryCertList(params) {
    return get('/wx/certificate/query', params);
};
// pages/index.vue中， 金额选择列表，和随机选择列表， 对应的字段为， chooseList， randomList
var apis_queryPayConfig = function queryPayConfig() {
    return get('/wx/pay/config', undefined);
};

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/assign.js
var object_assign = __webpack_require__("woOf");
var assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/fastclick/lib/fastclick.js
var fastclick = __webpack_require__("v5o6");
var fastclick_default = /*#__PURE__*/__webpack_require__.n(fastclick);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//
//
//
//

/* harmony default export */ var App = ({
  name: 'app'
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//
//
//
//

/* harmony default export */ var selectortype_script_index_0_src_App = ({
  name: 'app'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77c9a1c7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('keep-alive',[(_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1),_vm._v(" "),(!_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: App_render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (esExports);
// CONCATENATED MODULE: ./src/App.vue
function injectStyle (ssrContext) {
  __webpack_require__("Xkej")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  selectortype_script_index_0_src_App,
  selectortype_template_index_0_src_App,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_App = (Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/toConsumableArray.js
var toConsumableArray = __webpack_require__("Gu7T");
var toConsumableArray_default = /*#__PURE__*/__webpack_require__.n(toConsumableArray);

// CONCATENATED MODULE: ./src/router/main.js
var mainRouter = [{
    path: '/',
    name: '首页',
    component: function component() {
        return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, "2NXm"));
    },
    meta: {
        title: '感谢您的爱心捐赠'
    }
}, {
    path: '/cert',
    name: '证书',
    component: function component() {
        return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, "eudZ"));
    },
    meta: {
        title: '感谢您的爱心捐赠'
    }
}, {
    path: '/query',
    name: '查询',
    component: function component() {
        return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "Ui3t"));
    },
    meta: {
        title: '捐款信息查询',
        keepAlive: true
    }
}];

/* harmony default export */ var main = (mainRouter);
// CONCATENATED MODULE: ./src/router/index.js






vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);

/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
  routes: [].concat(toConsumableArray_default()(main))
}));
// EXTERNAL MODULE: ./src/utils/index.js
var utils = __webpack_require__("0xDb");

// EXTERNAL MODULE: ./src/apis/index.js + 1 modules
var apis = __webpack_require__("Apws");

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/wechat/index.js + 1 modules
var wechat = __webpack_require__("n6Wb");

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/toast/index.js + 1 modules
var toast = __webpack_require__("3BeM");

// CONCATENATED MODULE: ./src/config/index.js
var shareConfig = {
    title: '感谢您的热心捐助',
    link: '//donate.shmednew.com/#/',
    imgUrl: 'http://donate.shmednew.com/logo.jpeg',
    desc: '糖尿病干预救助专项基金感谢您对孩子们的帮助！关爱糖尿病儿童，关爱中国的未来！'
};
// CONCATENATED MODULE: ./src/main.js














vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);
vue_esm["a" /* default */].use(wechat["a" /* default */]);
vue_esm["a" /* default */].use(toast["a" /* default */]);

router.beforeEach(function (to, from, next) {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  var openId = Object(utils["a" /* getOpenId */])();
  if (openId) {
    next();
  } else {
    var url = encodeURIComponent(location.href);
    window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx9dae4a3e9c1bb204&redirect_uri=' + location.origin + '/grant&response_type=code&scope=snsapi_userinfo&state=' + url + '#wechat_redirect';
  }
});
Object(apis["c" /* getJssdkSingature */])({

  data: location.toString()
}).then(function (res) {
  var data = assign_default()({}, res.data, {

    jsApiList: ['chooseWXPay', 'updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareTimeline', 'onMenuShareAppMessage']
  });
  vue_esm["a" /* default */].wechat.config(data);
  vue_esm["a" /* default */].wechat.ready(function () {
    vue_esm["a" /* default */].wechat.updateAppMessageShareData && vue_esm["a" /* default */].wechat.updateAppMessageShareData(shareConfig);
    vue_esm["a" /* default */].wechat.updateTimelineShareData && vue_esm["a" /* default */].wechat.updateTimelineShareData(shareConfig);
    vue_esm["a" /* default */].wechat.onMenuShareTimeline && vue_esm["a" /* default */].wechat.onMenuShareTimeline(shareConfig);
    vue_esm["a" /* default */].wechat.onMenuShareAppMessage && vue_esm["a" /* default */].wechat.onMenuShareAppMessage(shareConfig);
  });
});
fastclick_default.a.attach(document.body);

/* eslint-disable no-new */
new vue_esm["a" /* default */]({
  router: router,
  render: function render(h) {
    return h(src_App);
  }
}).$mount('#app-box');

/***/ }),

/***/ "Xkej":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "labs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rLAy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/safari-fix.js
var safari_fix = __webpack_require__("xNvf");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/toast/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var toast = ({
  name: 'toast',
  mixins: [safari_fix["a" /* default */]],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: String,
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    currentTransition: function currentTransition() {
      if (this.transition) {
        return this.transition;
      }
      if (this.position === 'top') {
        return 'vux-slide-from-top';
      }
      if (this.position === 'bottom') {
        return 'vux-slide-from-bottom';
      }
      return 'vux-fade';
    },
    toastClass: function toastClass() {
      return {
        'weui-toast_forbidden': this.type === 'warn',
        'weui-toast_cancel': this.type === 'cancel',
        'weui-toast_success': this.type === 'success',
        'weui-toast_text': this.type === 'text',
        'vux-toast-top': this.position === 'top',
        'vux-toast-bottom': this.position === 'bottom',
        'vux-toast-middle': this.position === 'middle'
      };
    },
    style: function style() {
      if (this.type === 'text' && this.width === 'auto') {
        return { padding: '10px' };
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val) {
        this.$emit('input', true);
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
          _this.fixSafariOverflowScrolling('touch');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/toast/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_toast = ({
  name: 'toast',
  mixins: [safari_fix["a" /* default */]],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: String,
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    currentTransition: function currentTransition() {
      if (this.transition) {
        return this.transition;
      }
      if (this.position === 'top') {
        return 'vux-slide-from-top';
      }
      if (this.position === 'bottom') {
        return 'vux-slide-from-bottom';
      }
      return 'vux-fade';
    },
    toastClass: function toastClass() {
      return {
        'weui-toast_forbidden': this.type === 'warn',
        'weui-toast_cancel': this.type === 'cancel',
        'weui-toast_success': this.type === 'success',
        'weui-toast_text': this.type === 'text',
        'vux-toast-top': this.position === 'top',
        'vux-toast-bottom': this.position === 'bottom',
        'vux-toast-middle': this.position === 'middle'
      };
    },
    style: function style() {
      if (this.type === 'text' && this.width === 'auto') {
        return { padding: '10px' };
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val) {
        this.$emit('input', true);
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
          _this.fixSafariOverflowScrolling('touch');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25afd1ad","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/toast/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-toast"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowMask && _vm.show),expression:"isShowMask && show"}],staticClass:"weui-mask_transparent"}),_vm._v(" "),_c('transition',{attrs:{"name":_vm.currentTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-toast",class:_vm.toastClass,style:({width: _vm.width})},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.type !== 'text'),expression:"type !== 'text'"}],staticClass:"weui-icon-success-no-circle weui-icon_toast"}),_vm._v(" "),(_vm.text)?_c('p',{staticClass:"weui-toast__content",style:(_vm.style),domProps:{"innerHTML":_vm._s(_vm.text)}}):_c('p',{staticClass:"weui-toast__content",style:(_vm.style)},[_vm._t("default")],2)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_toast = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/toast/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("labs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_toast,
  src_components_toast,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_toast = __webpack_exports__["a"] = (Component.exports);


/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.8fc13782cbae3fe9bc69.js